import { TableData } from "./table";
import {
    DefaultWorkflow,
    EditorGeneration,
    LaunchSource,
    Profile,
    QuotaType,
} from "services/workflows/WorkflowService";

export interface EditorMetadata {
    profile: Profile;
}

export interface Workflow {
    name: string;
    version: string;
    editorMetadata?: EditorMetadata;
}

export function isWorkflow(candidate: unknown): candidate is Workflow {
    const workflow = candidate as Workflow;
    return workflow.name !== undefined && workflow.version !== undefined;
}

export interface WorkflowsData {
    count: number;
    cursor: string;
    workflowTableData: WorkflowTableData[];
}

export interface ConnectedWorkflowsDto {
    parent_workflows: string[];
    sub_workflows: string[];
    run_diagnose_workflows: string[];
    run_process_flow_workflows: string[];
    remote_workflow_count: number;
    grading_panel_workflows: [];
    for_each_workflows: [];
    advanced_grading_workflows: [];
    collect_workflows: [];
}

export interface ConnectedWorkflows {
    parentWorkflows: string[];
    subWorkflows: string[];
    runDiagnoseWorkflows: string[];
    runProcessFlowWorkflows: string[];
    remoteWorkflows: number;
    gradingPanelWorkflows: string[];
    collectWorkflows: string[];
    forEachWorkflows: string[];
    advancedGradingWorkflows: string[];
    totalConnectedWorkflows: number;
}

export interface WorkflowTableData extends TableData {
    name: string;
    uuid: string;
    id: number;
    product: string;
    profile: Profile;
    description: string;
    createdDate: string;
    modified: string;
    creator: string;
    defaultWorkflow: DefaultWorkflow;
    workflow: Workflow;
    userUuid: string;
    enabled: boolean;
    own: boolean;
    editorVersion: string;
    editorGeneration: EditorGeneration;
    connectedWorkflows: ConnectedWorkflows;
    secured: boolean;
    launchSource: LaunchSource;
    launchType?: LaunchType;
    parameters?: Record<string, unknown>;
    schedule?: ScheduleStatus;
    assetGrading?: boolean;
}

export interface WorkflowVersionHistoryData {
    workflowUuid: string;
    editorVersion: string;
    createdDate: string;
    s3VersionId: string;
}

export interface QuotaData {
    tenantUuid: string;
    quotaType: QuotaType;
    total: number;
    used: number;
}

export interface VersionsData {
    id: string;
    modified: string;
    modifiedBy: string;
}

export interface FilterState {
    from: string;
    to: string;
}

export enum WorkflowEntityType {
    WORKFLOW = "WORKFLOW",
    TEMPLATE = "TEMPLATE",
    SUB_WORKFLOW = "SUB_WORKFLOW",
}

export enum LaunchType {
    MANUAL = "MANUAL",
    REPORT_IMPORT = "REPORT_IMPORT",
}

export enum ScheduleStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
    NONE = "NONE",
}

export type ActionType = "create" | "edit" | "update";

export type Frequency = "HOURLY" | "DAILY" | "WEEKLY" | "MONTHLY";

export interface Recurrence {
    every?: number;
    time?: string;
    days?: string[];
    day?: number;
}
export interface ScheduleRequest {
    frequency: Frequency;
    recurrence: Recurrence;
    timezone: string;
    enabled: boolean;
    parameters: Record<string, unknown>;
}

export interface ScheduleResponse {
    frequency: Frequency;
    recurrence: Recurrence;
    timezone: string;
    enabled: boolean;
    parameters: Record<string, unknown>;
}
